function getRandomInt(min: number, max: number) {
  const minCeiled = Math.ceil(min);
  const maxFloored = Math.floor(max);
  return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive
}

export const getSHA256Hash = async (input: any): Promise<string> => {
  const SHA256 = await import("crypto-js/sha256").then((module) => module.default);

  const uniqueInput = `${input}-${Date.now()}`;
  const hash = SHA256(uniqueInput).toString();
  const hashNumber = parseInt(hash, 16) % 1e15;

  return `${hashNumber}${Date.now()}${getRandomInt(1e14, 1e15)}`;
};
/**
 * Generates a new microchip number based on the input string.
 *
 * @param {string} input - A string containing horse information (typically name + sire + dam + farm + year_of_birth).
 * @returns {Promise<string>} A Promise that resolves to a 15-digit microchip number.
 */
export const generateNewMicrochipId = async (input: string): Promise<string> => {
  const hash = await getSHA256Hash(input);
  const hashWithoutZeros = hash.toString().replace(/0/g, "");
  const newMicrochip = `00${hashWithoutZeros.slice(-13)}`;
  return newMicrochip;
};
